import Node from './Node';

/*
 * @class VideoBoxMute
 * @mixes $w.Node
 * @viewername wysiwyg.viewer.components.MediaPlayerControls
 * @definitionId wysiwyg.viewer.components.MediaPlayerControls
 * @tagname videoBoxMute
 */
class VideoBoxMute extends Node {}

export default VideoBoxMute;